import { BehaviorSubject } from "rxjs";

class SimpleState<T> {
    state$: BehaviorSubject<T>;

    constructor(initialState: T) {
        this.state$ = new BehaviorSubject(initialState);
    }

    selectState() {
        return this.state$.asObservable();
    }

    setState(newState: T) {
        this.state$.next(newState);
    }
}

export default SimpleState;
